import { defineStore } from "pinia";
// import { useRole } from "./role";
import { LoggedUserNetworkType } from "@/types/network";
import { getLoggedUserNetworks } from "@/api/apiclient/networks";

export const useNetwork = defineStore("network", {
  state: () => {
    return {
      loggedUserNetworks: [] as Array<LoggedUserNetworkType>,
    };
  },
  actions: {
    async init(force = false) {
      if (this.loggedUserNetworks.length && !force) return;
      this.loggedUserNetworks.length = 0;
      try {
        const resNetworks = await getLoggedUserNetworks();
        // this.loggedUserNetworks = [];
        this.loggedUserNetworks.push(...(resNetworks?.data ?? []));
      } catch (error) {
        console.error("Failed to fetch logged user networks:", error);
      }
    },
    resetList(): void {
      this.loggedUserNetworks.length = 0;
    },
  },
  getters: {
    // getRoleOnNetworkOptions(): { text: string; value: string }[] {
    //   return roleOnNetwork.map((x) => {
    //     return {
    //       text: x,
    //       value: x,
    //     };
    //   });
    // },
    // getRoleOptions(): { text: string; value: string }[] {
    //   return role.map((x) => {
    //     return {
    //       text: x.name,
    //       value: x.id,
    //     };
    //   });
    // },
  },
});
